import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';
import type { GlassHouseBrandGroupIndexCardStackContentViewModel } from '../../../../index-cards-3x5/glass-house-brand-group-index-card-stack-content/glass-house-brand-group-index-card-stack-content-view-model';
import { PrintCardColumnViewModel } from '../../../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';

@Component({
  selector: 'app-glass-brands-house-price',
  templateUrl: './glass-house-brands-price.component.html',
  styleUrl: './glass-house-brands-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandsPriceComponent extends RenderContextComponent {
  @Input() parentViewModel: GlassHouseBrandGroupIndexCardStackContentViewModel;
  @Input() columnViewModel: PrintCardColumnViewModel;
  setupViews() {}
  setupBindings() {}
  removeDollarSign = (price: string): string => price?.replace('$', '');
}
